import localforage from 'localforage';

const valueSuffix = 'v';
const expirySuffix = 'e';

localforage.config({
  name: 'vodaApp',
  storeName: 'authStore',
  driver: [
    localforage.INDEXEDDB,
    localforage.WEBSQL,
    localforage.LOCALSTORAGE
  ]
});

localforage.ready().catch(err => {
  console.warn('IndexedDB not ready, forcing fallback driver:', err);
  localforage.setDriver([
    localforage.WEBSQL,
    localforage.LOCALSTORAGE
  ]);
});

const ready = localforage.ready().catch(err => {
  console.warn('localForage not ready, falling back', err);
});

async function ensureReady() {
  await ready;
}

const getItemValue = async (key) => {

  let res = null;
  await ensureReady();
  try {
    res = await localforage.getItem(`${key}:${valueSuffix}`);
    res = res ? res : JSON.parse(sessionStorage.getItem(`${key}:${valueSuffix}`) || 'null');
    if (res !== null && res !== undefined) {
      sessionStorage.removeItem(`${key}:${valueSuffix}`);
    }
  } catch (err) {
    console.error(`Failed to fetch storage item value with key ${key}`, err);
    //throw new Error('StorageGetItemValue');
    try {
      res = res ? res : JSON.parse(sessionStorage.getItem(`${key}:${valueSuffix}`) || 'null');
    } catch {
      console.warn('Second attempt failed, fallback to sessionStorage');
      res = JSON.parse(sessionStorage.getItem(`${key}:${valueSuffix}`) || 'null');
    }
  }
  return res;
};

const getItemExpiry = async (key) => {

  let res = null;
  await ensureReady();
  try {
    res = await localforage.getItem(`${key}:${expirySuffix}`);
    res = res ? res : JSON.parse(sessionStorage.getItem(`${key}:${expirySuffix}`) || 'null');
    if (res !== null && res !== undefined) {
      sessionStorage.removeItem(`${key}:${expirySuffix}`);
    }
  } catch {
    console.error(`Failed to fetch storage item expiry with key ${key}`);
    //throw new Error('StorageGetItemExpiry');
    res = JSON.parse(sessionStorage.getItem(`${key}:${expirySuffix}`) || 'null');
  }
  return res;
};

const getItem = async (key) => {
  let res = null;
  await ensureReady();
  try {
    const value = await getItemValue(key);
    const expiry = await getItemExpiry(key);
    if (!isNaN(expiry) && (+expiry >= new Date().getTime() || +expiry <= 0)) {
      res = value;
    }
  } catch (err) {
    console.error(`Failed to fetch storage item with key ${key}`, err);
    // throw new Error('StorageGetItem');
    const value = await getItemValue(key);
    const expiry = await getItemExpiry(key);
    if (!isNaN(expiry) && (+expiry >= new Date().getTime() || +expiry <= 0)) {
      res = value;
    }
  }

  return res;
};

const setItem = async (key, value, ttlMs = 0) => {
  let success = false;
  // const exp = !isNaN(ttlMs) && +ttlMs > 0 ? new Date().getTime() + ttlMs : 0;
  const exp = value?.expiry || (ttlMs > 0 ? Date.now() + ttlMs : 0);

  await ensureReady();
  sessionStorage.setItem(`${key}:${valueSuffix}`, JSON.stringify(value));
  sessionStorage.setItem(`${key}:${expirySuffix}`, JSON.stringify(exp));
  success = true;
  try {
    await localforage.setItem(`${key}:${valueSuffix}`, value);
    await localforage.setItem(`${key}:${expirySuffix}`, exp);
    await new Promise(r => setTimeout(r, 20));
    success = true;
  } catch (err) {
    console.error(`Failed to store storage item with key ${key}`, err);
    //  throw new Error('StorageSetItem');
    sessionStorage.setItem(`${key}:${valueSuffix}`, JSON.stringify(value));
    sessionStorage.setItem(`${key}:${expirySuffix}`, JSON.stringify(exp));
    success = true;
  }

  return success;
};

const clear = async () => {
  await ensureReady();
  try {
    sessionStorage.clear();
    return await localforage.clear();
  } catch (err) {
    console.warn('localForage clear failed', err);
    return sessionStorage.clear();
  }
};

const storage = {
  getItemValue,
  getItemExpiry,
  getItem,
  setItem,
  clear
};

export default storage;